import { render, staticRenderFns } from "./dataIndex.vue?vue&type=template&id=6ab55917&scoped=true"
import script from "./dataIndex.vue?vue&type=script&lang=js"
export * from "./dataIndex.vue?vue&type=script&lang=js"
import style0 from "./dataIndex.vue?vue&type=style&index=0&id=6ab55917&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab55917",
  null
  
)

export default component.exports